import { TmBaseError } from '@/core/error/tmBaseError'

export class TmTableError extends TmBaseError {
  public name = 'TmTableError'
}
